import { render, staticRenderFns } from "./SecondAssignmentPage.vue?vue&type=template&id=98bf39e2&scoped=true&"
import script from "./SecondAssignmentPage.vue?vue&type=script&lang=js&"
export * from "./SecondAssignmentPage.vue?vue&type=script&lang=js&"
import style0 from "./SecondAssignmentPage.vue?vue&type=style&index=0&id=98bf39e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98bf39e2",
  null
  
)

export default component.exports